module.exports = __webpack_public_path__ + "img/chevron-left.e7fad4c2.svg";